import React, { useEffect } from "react";

import { theme } from "@gcui/react";
import { ThemeProvider } from "@material-ui/core/styles";

import Navbar from "./components/header";
import Main from "./containers/main";
// import SnackBar from "./components/shared/snackbar/SnackBar";
import { useSelector, useDispatch } from "react-redux";
import { setBranding } from "./reducers/loginReducer";


function App() {

  const dispatch = useDispatch(); 
  const activeBrand = useSelector(state => state.login.activeBrand);

  useEffect(() => {
          // read the branding json
      fetch("branding.json")
        .then((res) => res.json())
        .then((branding) => {
          const brandingObj = branding.find((b) => b.brand.toLowerCase() === activeBrand.toLowerCase());
          if (brandingObj) {
           dispatch(setBranding(brandingObj));
           if (brandingObj.favicon) {
             const link = document.querySelector("link[rel='icon']");
             if (link) {
               link.href = `${process.env.PUBLIC_URL}/${brandingObj.favicon}`;
             }
           }
          }
        })
        .catch((err) => {
          console.error("Error fetching data from the branding json file:", err);
        });

  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Navbar />
        <Main />
        {/* <SnackBar /> */}
      </div>
    </ThemeProvider>
  );
}

export default App;
